// One tool call Claude made through the Atlas connector (Admin::ClaudeQuestionsController).
export type ToolCall = {
  id: string
  at: string
  user_id: string
  person: string
  question: string | null
  tool: string
  arguments: Record<string, unknown>
  row_count: number | null
  missing: string[]
  error: string | null
  duration_ms: number
}

// Calls Claude made for one question: same person, same question, minutes apart.
export type QuestionGroup = { key: string; person: string; question: string | null; calls: ToolCall[] }

const SAME_QUESTION_WINDOW_MS = 10 * 60 * 1000

// calls come newest first. Neighbouring calls by the same person with the same
// question (ignoring case and spaces), close in time, read as one question.
// Groups stay newest first; calls inside a group read in the order Claude made them.
export function groupByQuestion(calls: ToolCall[]): QuestionGroup[] {
  const groups: QuestionGroup[] = []
  for (const call of calls) {
    const last = groups[groups.length - 1]
    const previous = last?.calls[0]
    const sameQuestion =
      previous &&
      previous.user_id === call.user_id &&
      normalize(previous.question) === normalize(call.question) &&
      new Date(previous.at).getTime() - new Date(call.at).getTime() <= SAME_QUESTION_WINDOW_MS
    if (last && sameQuestion) {
      last.calls.unshift(call)
    } else {
      groups.push({ key: call.id, person: call.person, question: call.question, calls: [call] })
    }
  }
  return groups
}

function normalize(question: string | null): string {
  return (question ?? "").trim().replace(/\s+/g, " ").toLowerCase()
}
